import { baseUrl } from "./env";
import { generateAuthToken } from "./util";

const aParam = "YXBpNGVycA==";
const pParam = "ZXJwLmhlbGVucw==";

export default async (url = "", data = {}, type = "GET", method = "fetch") => {
  type = type.toUpperCase();
  var helens_y = window.sessionStorage.getItem("helens_y_1");
  var mainUrl = "";

  // 本地访问使用代理
  if(helens_y == 2){
    mainUrl = process.env.NODE_ENV == "development" ? "/yerpapi/" : "https://yerpapi.helensbar.com/";
  }else{
    mainUrl = process.env.NODE_ENV == "development" ? "/erpapi/" : "https://erpapi.helensbar.com/";
  }
  
  url = mainUrl + url;
  const time = new Date().getTime();
  const token = generateAuthToken(aParam, time, pParam);

  data.time = time;
  data.authtoken = token;

  if (type == "GET") {
    let dataStr = ""; //数据拼接字符串
    Object.keys(data).forEach(key => {
      dataStr += key + "=" + data[key] + "&";
    });

    if (dataStr !== "") {
      dataStr = dataStr.substr(0, dataStr.lastIndexOf("&"));
      url = url + "?" + dataStr;
    }
  }

  if (window.fetch && method == "fetch") {
    let requestConfig = {
      credentials: "omit",
      method: type,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      mode: "cors",
      cache: "force-cache"
    };

    if (type == "POST") {
      Object.defineProperty(requestConfig, "body", {
        value: JSON.stringify(data)
      });
    }

    try {
      const response = await fetch(url, requestConfig);
      const responseJson = await response.json();
      return responseJson;
    } catch (error) {
      throw new Error(error);
    }
  } else {
    return new Promise((resolve, reject) => {
      let requestObj;
      requestObj = new XMLHttpRequest();
      let sendData = "";
      if (type == "POST") {
        sendData = JSON.stringify(data);
      }

      requestObj.open(type, url, true);
      requestObj.setRequestHeader(
        "Content-type",
        "application/x-www-form-urlencoded"
      );
      requestObj.send(sendData);

      requestObj.onreadystatechange = () => {
        if (requestObj.readyState == 4) {
          if (requestObj.status == 200) {
            let obj = requestObj.response;
            if (typeof obj !== "object") {
              obj = JSON.parse(obj);
            }
            resolve(obj);
          } else {
            reject(requestObj);
          }
        }
      };
    });
  }
};
